// Rótulos em pt-BR para os valores internos (enums em inglês) mostrados no backoffice.
import { ACCOUNT_ROLE_LABEL, ACCOUNT_STATUS_LABEL } from '../account/labels'

const ENUM_LABEL: Record<string, string> = {
  // situação da conta / assinatura
  trial: 'Em teste', trialing: 'Em teste', active: 'Ativa', past_due: 'Pagamento atrasado', readonly: 'Somente leitura', suspended: 'Suspensa', canceled: 'Cancelada', archived: 'Arquivada',
  // forma de cobrança
  fake: 'Simulada (teste)', asaas: 'Asaas',
  // papéis
  owner: ACCOUNT_ROLE_LABEL.owner, admin: ACCOUNT_ROLE_LABEL.admin, member: ACCOUNT_ROLE_LABEL.member,
  manager: 'Gestor(a)', analyst: 'Analista', viewer: 'Só leitura', client: 'Cliente',
  // conexões
  needs_reconnect: 'Precisa reconectar', error: 'Com erro', disconnected: 'Desconectada',
  // ações nas plataformas
  proposed: 'Proposta', approved: 'Aprovada', queued: 'Na fila', submitting: 'Enviando', submitted: 'Enviada', verifying: 'Verificando',
  succeeded: 'Concluída', failed: 'Falhou', conflict: 'Conflito', reverted: 'Revertida', blocked: 'Bloqueada',
  user: 'Usuário', recommendation: 'Sugestão', autopilot: 'Piloto', builder: 'Criador de campanhas', system: 'Sistema', staff: 'Equipe interna',
  // modos do piloto
  suggest: 'Só sugerir', copilot: 'Copiloto', auto: 'Automático',
  // plataformas
  google_ads: 'Google Ads', meta: 'Meta',
}

/** Traduz um valor interno conhecido; o que não está no mapa volta como veio. */
export const enumLabel = (v: string | null | undefined): string => (v ? (ENUM_LABEL[v] ?? v) : '—')

export const accountStatusLabel = (s: string) => (s in ACCOUNT_STATUS_LABEL ? ACCOUNT_STATUS_LABEL[s as keyof typeof ACCOUNT_STATUS_LABEL].text : enumLabel(s))

/** Valor de um detalhe de auditoria em texto legível (Sim/Não, listas, enums traduzidos). */
export function auditValue(v: unknown): string {
  if (v == null) return '—'
  if (typeof v === 'boolean') return v ? 'Sim' : 'Não'
  if (typeof v === 'string') return enumLabel(v)
  if (typeof v === 'number') return v.toLocaleString('pt-BR')
  if (Array.isArray(v)) return v.map(auditValue).join(', ')
  return JSON.stringify(v)
}

/** Resumo "chave: valor" de um objeto de auditoria (só o primeiro nível). */
export function auditEntries(target: unknown): Array<[string, string]> {
  if (target == null) return []
  if (typeof target !== 'object' || Array.isArray(target)) return [['valor', auditValue(target)]]
  return Object.entries(target as Record<string, unknown>).map(([k, v]) => [k, auditValue(v)])
}
